// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardPage_wrapper__bT5Kb","inner":"DashboardPage_inner__x-eB4"};